import { combineReducers } from 'redux'
import expanded from './expanded'
import campaign from './campaign'
import newStageNameText from './newStageNameText'
import calendarListView from './calendarListView'
import funnelCalendarView from './funnelCalendarView'
import newEventGoal from './newEventGoal'
import funnelStageExpanded from './funnelStageExpanded'
import taskModalOpen from './taskModalOpen'
import bottomNavigation from './bottomNavigation'
import stageSelectedForContactView from './stageSelectedForContactView'
import subentityOptions from './subentityOptions'

export default combineReducers({
	bottomNavigation,
	campaign,
	expanded,
	newStageNameText,
	calendarListView,
	funnelCalendarView,
	newEventGoal,
	funnelStageExpanded,
	taskModalOpen,
	stageSelectedForContactView,
	subentityOptions,
})
